import {User} from "../api";
import {hasRoles, useUserAuditedInboxes} from "../context/auth";

export function useCanAudit(user?: User) {
	const auditedInboxes = useUserAuditedInboxes();
	return hasRoles(user, ["SuperUser"])
		|| (hasRoles(user, ["OebbAdministrator", "OebbUser"]) && auditedInboxes.length > 0);
}
